// pages/FormViewerPage/sections/TrustBadgesFooterSection.tsx — Below-form trust badges / default assurance
import React from 'react';
import type { Form } from '../../../types';
import { ms } from '../../../locales/ms';
import TrustBadges from '../../../components/TrustBadges';

export const TrustBadgesFooterSection: React.FC<{ form: Form }> = ({ form }) => {
    if (form.trustBadgeSettings?.active && form.trustBadgeSettings.position === 'below-form') {
        return (
            <div className="mt-6 pt-6 border-t border-slate-200 dark:border-slate-700"><TrustBadges settings={form.trustBadgeSettings} /></div>
        );
    }
    if (form.trustBadgeSettings?.active) return null;
    return (
        <div className="mt-6 pt-6 border-t border-slate-200 dark:border-slate-700"><div className="grid grid-cols-3 gap-3 text-center">
            <div className="flex flex-col items-center gap-1">
                <svg className="w-8 h-8" viewBox="0 0 24 24">
                    <path fill="#22c55e" d="M12 1.8l8 2.9v6.1c0 5.2-3.6 9.7-8 11.4-4.4-1.7-8-6.2-8-11.4V4.7l8-2.9z" />
                    <path fill="none" stroke="#fff" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" d="M8.5 12l2.4 2.4 4.6-4.8" />
                </svg>
                <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">{ms(form, m => m.trustPayment, 'Pembayaran')}</span><span className="text-xs text-slate-500 dark:text-slate-400">{ms(form, m => m.trustPaymentSub, 'Aman')}</span>
            </div>
            <div className="flex flex-col items-center gap-1">
                <svg className="w-8 h-8" viewBox="0 0 24 24">
                    <path fill="#3b82f6" d="M12 1.8l8.5 4.7v9L12 20.2l-8.5-4.7v-9L12 1.8z" />
                    <path fill="#1d4ed8" d="M12 1.8l8.5 4.7L12 11.2 3.5 6.5 12 1.8z" opacity=".55" />
                    <path fill="none" stroke="#fff" strokeWidth={1.6} strokeLinejoin="round" d="M3.5 6.5L12 11.2l8.5-4.7M12 11.2v9" />
                </svg>
                <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">{ms(form, m => m.trustProduct, 'Barang')}</span><span className="text-xs text-slate-500 dark:text-slate-400">{ms(form, m => m.trustProductSub, 'Original')}</span>
            </div>
            <div className="flex flex-col items-center gap-1">
                <svg className="w-8 h-8" viewBox="0 0 24 24">
                    <path fill="#8b5cf6" d="M2.5 6.5h11v9h-11v-9zM13.5 10h4l3 3.2v2.3h-7V10z" />
                    <circle cx="7" cy="17.5" r="2" fill="#8b5cf6" />
                    <circle cx="7" cy="17.5" r=".9" fill="#fff" />
                    <circle cx="17" cy="17.5" r="2" fill="#8b5cf6" />
                    <circle cx="17" cy="17.5" r=".9" fill="#fff" />
                    <path fill="#fff" d="M4 8.5h6v2H4zM4 11.5h4v1.5H4z" opacity=".85" />
                </svg>
                <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">{ms(form, m => m.trustShipping, 'Pengiriman')}</span><span className="text-xs text-slate-500 dark:text-slate-400">{ms(form, m => m.trustShippingSub, 'Cepat')}</span>
            </div>
        </div></div>
    );
};
